// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__Ocwlt","noBackground":"Footer_noBackground__UeaVA"};